<template>
  <div>
    <Headersys />
    <div class="content">
      <div class="realy-content">
        <div class="qrCode-box">
          <div v-for="(item, idx) in info" :key="idx">
            <img class="idCard-img" :src="item.images" alt="" />
            <!-- <div class="print-btn" @click="printPdfFile(item)">打印</div> -->
          </div>
          <div style="width: 100%; height: 35rem"></div>
        </div>
      </div>
      <div class="load-mask" id="loadDom" v-if="maskShow"></div>
    </div>
    <Back :print="print" @toPrintEve="printPdfFile" />

    <div class="lt-mask" v-if="failShow" @click="failShow = false">
      <div class="ly-body" @click.stop="">
        <div class="lt-item">未查询到该证照(证明)信息</div>
        <div class="cl-btn" @click="goBackFail">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
import lodop from "@/assets/js/doPrint.js";
import { Loading } from "element-ui";

export default {
  name: "",
  data() {
    return {
      // idCardUrl: "",
      info: [],
      loadingInstance: null,
      waitTime: 180,
      watiTimer: null,
      print: "1", //打印按钮
      validToken: "", //验证token
      inquireNum: 0, //请求次数
      failShow: false, //未查询到证照提示
      maskShow: false,
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
    };
  },
  created() {
    // this.info = JSON.parse(localStorage.getItem("asdfgh"));
    // this.info.forEach((el) => {
    //   // el.images = "data:image/png;base64," + el.imginfo;
    //   el.images = "data:image/png;base64," + el.imginfo.data.content[0]
    // });
  },
  mounted() {
    this.timeDown();
    var query = this.$route.query;
    var holderTypeCode = query.holderTypeCode;
    var certTypeCode = query.certTypeCode;
    var uniscid = query.uniscid;
    this.maskShow = true;
    // this.loadingInstance = Loading.service({ fullscreen: true, text: '正在查询', target: document.querySelector('#loadDom') });
    var localList =
      JSON.parse(localStorage.getItem(this.$store.state.suerInfo.cerno)) || [];
    var have = false;
    localList.forEach((el) => {
      if (el.class == certTypeCode) {
        have = true;
        this.info = el.list;
        this.print = "2";
        this.maskShow = false;
      }
    });
    if (!have) {
      setTimeout(() => {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "正在查询...",
          target: document.querySelector("#loadDom"),
        });
      }, 500);
      this.getLicence(holderTypeCode, certTypeCode, uniscid);
    }
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
      // var userInfo = JSON.parse(localStorage.getItem('USERINFO'))
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
  },
  destroyed() {
    // localStorage.removeItem("asdfgh");
    clearTimeout(this.watiTimer);
  },
  methods: {
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 180;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
    printPdfFile() {
      this.$rqt.print_save({
        type: this.$route.query.title,
        fmac: this.fmac,
        name: this.name,
        phone: this.phone,
        idCard: this.idCard,
      });
      this.maskShow = true;
      setTimeout(() => {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "正在打印...",
          target: document.querySelector("#loadDom"),
        });
      }, 500);
      this.info.forEach((el) => {
        // lodop.zzPrint(el.images)
        this.localPrint(el.printImg);
      });
      setTimeout(() => {
        this.loadingInstance.close();
      }, 16000);
    },
    localPrint(base64String) {
      this.$rqt.localhost_print({
        base64String,
      });
    },
    // 获取证照信息
    async getLicence(holderTypeCode, certTypeCode, uniscid) {
      await this.$rqt.Lwwan_getOnceTimeToken().then((res) => {
        this.validToken = res;
      });
      this.$rqt
        .Lwwan_getCertinfo({
          holderTypeCode,
          certTypeCode,
          token: localStorage.getItem("KWYSTOKEN"),
          validToken: this.validToken,
          uniscid,
        })
        .then((res) => {
          if (res.code == 200) {
            if (this.loadingInstance) {
              this.loadingInstance.close();
            }
            this.info = res.data.info;
            this.info.forEach((el) => {
              // el.images = "data:image/png;base64," + el.imginfo;
              el.images = "data:image/png;base64," + el.imginfo.data.content[0];
              el.printImg = el.imginfo.data.content[0];
            });
            this.inquireNum = 0;
            this.print = "2";
            this.maskShow = false;
            var cerno = this.$store.state.suerInfo.cerno;
            var localList = JSON.parse(localStorage.getItem(cerno)) || [];
            var local = {
              class: certTypeCode,
              list: this.info,
            };
            localList.push(local);
            localStorage.setItem(cerno, JSON.stringify(localList));
          } else {
            this.inquireNum++;
            if (this.inquireNum > 5) {
              this.wxShow = false;
              if (this.loadingInstance) {
                this.loadingInstance.close();
              }
              this.failShow = true;
              this.inquireNum = 0;
            } else {
              setTimeout(() => {
                this.getLicence(holderTypeCode, certTypeCode, uniscid);
              }, 2000);
            }
          }
        })
        .catch(() => {
          this.wxShow = false;
          this.loadingInstance.close();
          this.failShow = true;
        });
    },
    goBackFail() {
      this.failShow = false;
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 70%;
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  margin: auto;
  background-color: #fff;
  position: relative;
  // overflow: scroll;
}

.realy-content {
  width: 100%;
  height: calc(100vh - 42rem - 40px);
  overflow: scroll;
}

.realy-content::-webkit-scrollbar {
  display: none;
  /* 对于Chrome, Safari和Opera */
}

.qrCode-box {
  margin: auto;
  text-align: center;
}

.idCard-img {
  width: 180rem;
  margin-bottom: 2rem;
}

.print-btn {
  width: 34rem;
  height: 17rem;
  line-height: 17rem;
  background-color: rgb(34, 167, 244);
  color: #ffffff;
  text-align: center;
  border-radius: 10px;
  font-size: 7rem;
  cursor: pointer;
  margin: auto;
}

.print-btn:active {
  background-color: rgba(34, 167, 244, 0.5);
}

.lt-mask {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  background-color: rgba(0, 0, 0, 0.6);

  .ly-body {
    background-color: #fff;
    margin: auto;
    padding: 12rem;
    border-radius: 3rem;
    text-align: center;

    .lt-item {
      font-size: 8rem;
      margin-bottom: 2rem;

      .ipt {
        font-size: 8rem;
      }
    }

    .cl-btn {
      width: fit-content;
      margin: 6rem auto 0;
      padding: 3rem 6rem;
      background-color: #295eb5;
      font-size: 7rem;
      color: #ffffff;
      border-radius: 3rem;
    }

    .submit-btn {
      background-color: #24b34c;
    }

    .wxcode-img {
      display: block;
      margin: auto;
      width: 70rem;
      height: 70rem;
    }
  }
}

.load-mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
